import { TIMEOUT_DEFAULT } from '@/app/module/campaigns/definitions'
import { ContentFlow, LocalOnInvalidReply, LocalOnRetriesExhausted, LocalOnTimeout } from '@/app/module/campaigns/types'
import { unwrapActions, wrapActions } from '@/app/module/campaigns/utils/actions/wrap'

type WhatsappFlowOnInvalidAnswer = ContentFlow['onInvalidAnswer']
type WhatsappFlowOnRetriesExhausted = ContentFlow['onRetriesExhausted']
type WhatsappFlowOnTimeout = ContentFlow['onTimeout']

export type WhatsappFlowConfigs = {
  onInvalidAnswer: WhatsappFlowOnInvalidAnswer
  onTimeout: WhatsappFlowOnTimeout
  retries: number
  onRetriesExhausted: WhatsappFlowOnRetriesExhausted
}

export type WhatsappFlowConfigsState = {
  onInvalidAnswer: LocalOnInvalidReply
  onTimeout: LocalOnTimeout
  retries: number
  onRetriesExhausted: LocalOnRetriesExhausted
}

const isActionsConfigEnabled = (config: { actions?: unknown[] }) => !!config.actions?.length

const toFlowTimeout = (timeout: LocalOnTimeout['timeout']): WhatsappFlowOnTimeout['timeout'] => ({
  unit: (timeout?.unit || 'minute') as WhatsappFlowOnTimeout['timeout']['unit'],
  value: timeout?.value || TIMEOUT_DEFAULT,
})

export const fromWhatsappFlowConfigs = (configs: WhatsappFlowConfigs): WhatsappFlowConfigsState => ({
  onInvalidAnswer: {
    ...configs.onInvalidAnswer,
    actions: unwrapActions(configs.onInvalidAnswer.actions || []),
    enabled: isActionsConfigEnabled(configs.onInvalidAnswer),
  },
  onTimeout: {
    ...configs.onTimeout,
    actions: unwrapActions(configs.onTimeout.actions || []),
    enabled: isActionsConfigEnabled(configs.onTimeout),
  },
  retries: configs.retries,
  onRetriesExhausted: {
    ...configs.onRetriesExhausted,
    actions: unwrapActions(configs.onRetriesExhausted.actions || []),
    enabled: isActionsConfigEnabled(configs.onRetriesExhausted),
  },
})

export const toWhatsappFlowConfigs = (state: WhatsappFlowConfigsState): WhatsappFlowConfigs => ({
  onInvalidAnswer: {
    enabled: state.onInvalidAnswer.enabled,
    actions: state.onInvalidAnswer.enabled ? wrapActions(state.onInvalidAnswer.actions || []) : [],
  },
  onTimeout: {
    enabled: state.onTimeout.enabled,
    actions: state.onTimeout.enabled ? wrapActions(state.onTimeout.actions || []) : [],
    timeout: toFlowTimeout(state.onTimeout.timeout),
  },
  retries: state.retries,
  onRetriesExhausted: {
    enabled: state.onRetriesExhausted.enabled,
    actions: state.onRetriesExhausted.enabled ? wrapActions(state.onRetriesExhausted.actions || []) : [],
  },
})
